import React from 'react';
import useTranslate from '../../Hooks/useTranslate';
import { Typography, Box } from '@mui/material';

const CaptionValue = function CaptionValue({
  caption,
  value,
  captionColor = 'textSecondary',
  valueColor = 'textPrimary',
  reverse,
  direction = 'column',
  width,
  height,
  gap = '4px',
  flex,
  padding,
  textAlign,
  captionStyle,
  valueStyle,
  fallback = 'UNAVAILABLE',
  className,
  noWrap = true,
  omitCaption = false,
}) {
  const translate = useTranslate();
  return (
    <Box
      className={className}
      sx={{
        display: 'flex',
        flexDirection: reverse ? `${direction}-reverse` : direction,
        alignItems: direction === 'row' ? 'center' : 'stretch',
        width: width,
        gap: gap,
        height: height,
        flex: flex,
        padding: padding,
      }}
    >
      {/* `omitCaption` draws no caption node at all, where an empty one would still take its line.
          Off by default, so a caller that has always drawn one goes on doing so. */}
      {!omitCaption && (
        <Typography
          variant="body2"
          // A caption given as an element may hold a <div>, which a <p> cannot contain.
          component={React.isValidElement(caption) ? 'div' : undefined}
          color={captionColor}
          sx={{
            textAlign,
            userSelect: 'none',
            ...captionStyle,
          }}
          noWrap
        >
          {translate(caption)}
        </Typography>
      )}
      {typeof value === 'string' ||
      typeof value === 'number' ||
      (!value &&
        (typeof fallback === 'string' || typeof fallback === 'number')) ? (
        <Typography
          variant="body1"
          color={valueColor}
          sx={{
            textAlign,
            userSelect: 'none',
            color: valueColor?.includes('#') ? valueColor : undefined,
            ...valueStyle,
          }}
          noWrap={noWrap}
        >
          {translate(value) || value || translate(fallback)}
        </Typography>
      ) : (
        value || fallback
      )}
    </Box>
  );
};

export default CaptionValue;
